import React from "react"
import Banner from "../../containers/banner"
import About from "../../containers/about"
import Layout from "../../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Titlespan2 } from '../../components/title/index';
import AfterBanner from '../../containers/after-banner';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Industry Sectors" body={(
                <>
                    <h3>Internet of Things</h3>
                    <p><a className="text-white" href="/sectors">Back to sectors</a></p>
                </>
            )}/>
            <AfterBanner size={9} title="" subtitle="Overview">
                <p>The Internet of Things—the pervasive computing network of sensors and smart devices, combined with advanced analytics and cloud services—promises to disrupt products and services across industries. The Internet of Things (IoT) can not only help you get ahead today, its powerful outcomes and analytics can propel your business far into the future. we can help companies harness the power of IoT to deliver transformative outcomes and tangible business value.</p>
                <p>IoT solutions enable businesses to analyse data generated by sensors on physical objects in a world of intelligent, connected devices. This data can transform your business, revealing hidden patterns and insights that can help you make more informed decisions and take action more quickly.</p>
                <p>Internet of Things (IoT) solutions enable breakthrough results by connecting the physical world to the digital world in ways that can turn your pain points into competitive advantages:</p>
                <ul>
                    <li>Track, monitor, and stay up-to-date on your products and inventory in real time </li>
                    <li>Extend your service and support and deepen customer relationships through smart products </li>
                    <li>Gather and learn your equipment's vitals through small, wireless, and multi-stats sensors to anticipate failures before they happen </li>
                    <li>Turn real-time sensor data into actionable insights through big data tools, cognitive analytics, and machine learning </li>
                    <li>Apply mixed reality to transform your engineers into a remote team of experts accessible from anywhere via video through phone, tablet, or specialty glasses </li>
                </ul>
            </AfterBanner>
        </Layout>
    )
}

export default IndexPage
